import { render, staticRenderFns } from "./DoorLeaves.vue?vue&type=template&id=2a43840e"
import script from "./DoorLeaves.vue?vue&type=script&lang=ts"
export * from "./DoorLeaves.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports